<template>
  <div class="featured-cta">
    <div class="featured-cta__img" v-if="fields && fields.image">
      <sc-link v-if="fields && fields.imageUrl && fields.image" :field="fields.imageUrl">
        <sc-image v-if="fields && fields.image" :media="fields.image" />
      </sc-link>
      <sc-link
        v-if="fields && fields.imageBottomUrl && fields.imageBottom"
        :field="fields.imageBottomUrl"
      >
        <sc-image v-if="fields && fields.imageBottom" :media="fields.imageBottom" />
      </sc-link>
    </div>
    <div class="featured-cta__text">
      <sc-text tag="h2" class="cta-title" v-if="fields && fields.title" :field="fields.title" />
      <sc-richText
        tag="div"
        class="featured-cta__content"
        v-if="fields && fields.content"
        :field="fields.content"
      />
      <sc-link
        v-if="fields && fields.cta"
        :field="fields.cta"
        class="c-cta--secondary"
        :class="fields.cta.value.class"
      >
        {{ fields?.cta?.value?.text }}
        <span class="sr-only">{{ fields?.title?.value }}</span>
      </sc-link>
    </div>
  </div>
</template>

<script>
import { Text, Image, Link, RichText } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Home-Featured-CTA',
  components: {
    ScText: Text,
    ScImage: Image,
    ScLink: Link,
    ScRichText: RichText
  },
  props: {
    fields: {
      type: Object
    }
  },
  computed: {
    isEditing() {
      // this.$jss is defined on the Vue instance by the SitecoreJssPlugin and provides
      // reactive access to the `sitecoreContext` provided in layout service data.
      return this.$jss.sitecoreContext().pageEditing;
    }
  }
};
</script>

<style lang="scss" scoped>
.featured-cta {
  padding-bottom: 1rem;
  margin-top: 2rem;
  position: relative;
  @include padding-x-thick;

  @include tablet-up {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    @include padding-y(0, 2rem);
    margin-top: 4rem;
  }

  @include desktop-up {
    @include padding-y(0, 5rem);
    margin-top: 8rem;
  }

  &:after {
    content: '';
    width: calc(100% - 4rem);
    height: 0.1rem;
    padding: 0 2rem;
    background-color: $divider;
    position: absolute;
    bottom: 0;
    left: 2rem;

    @include desktop-up {
      width: calc(100% - 36rem);
      padding: 0 18rem;
      left: auto;
    }
  }

  &__img {
    position: relative;
    width: 65%;
    background-color: $white;
    padding: 3.8rem 2.5rem;
    border-top: 3px solid $orange;
    box-shadow: 0 0.3rem 0.7rem 0 rgb(0 0 0 / 12%), 0 1.8rem 1.7rem 0 rgb(0 0 0 / 12%);
    align-self: flex-start;
    z-index: 1;
    overflow: hidden;
    transform: translateY(2rem);

    @include tablet-up {
      transform: translateY(-2rem);
    }

    @include desktop-up {
      width: 50%;
      transform: translateY(-4rem);
      padding: 5rem 5rem 5rem 6.2rem;
      z-index: auto;
    }

    a {
      display: block;
      line-height: 0;
      font-size: 0;
      color: transparent;
    }

    img {
      width: initial;
      max-width: 100%;
      height: auto;
    }
  }
  .wrapper {
    @include padding-x-thick;
  }

  &__text {
    position: relative;
    width: 100%;
    padding: 5rem 2rem 2rem 2rem;
    border-top: 3px solid $orange;
    flex: 0 1 auto;

    @include tablet-up {
      padding: 3rem 2rem 2rem 2rem;
    }

    @include desktop-up {
      width: 50%;
      padding: 3rem 0 2rem 4rem;
    }

    .cta-title {
      font-size: 2.4rem;
      line-height: 3rem;
      font-weight: 200;
      padding-bottom: 1rem;

      @include desktop-up {
        font-size: 3.6rem;
        line-height: 4.5rem;
        padding-bottom: 1rem;
      }
    }
  }

  &__content {
    font-size: 1.6rem;
    line-height: 2rem;
    margin-bottom: 2.5rem;

    @include desktop-up {
      font-size: 1.9rem;
      line-height: 2.6rem;
      margin-bottom: 3rem;
    }
  }
}
</style>
